<template lang="pug">
  header.app-header
    nav.navbar
      .container
        .navbar-brand
          .navbar-item
            router-link.brand(:to="{name: 'ListPage'}")
              .brand-icon
                img.has-shadow(alt='Frequency List', role='presentation', src='/static/logo-frequency-list-v4.png')
              .brand-content
                .brand-title
                  img(alt='Frequency List', role='presentation', src='/static/logo-frequency-list-full.png')
                .brand-subtitle Explore the top 5000 words in English
          .navbar-burger.burger(
            data-target='mainNav'
            @click="showNavBar =  !showNavBar"
            :class="{'is-active': showNavBar}")
            span
            span
            span
        #mainNav.navbar-menu(:class="{'is-active': showNavBar}")
          .navbar-end
            .navbar-item
              button.button.is-outlined.is-dark.mr-3(
              v-if="videoSeen && $route.path == '/'"
              @click="toggleVideoSeen")
                | Watch demo video
              router-link.button.is-primary(
                :class="{'is-outlined': $route.path.indexOf('sign_up') !== -1}"
                v-if="!user.id"
                :to="{name: 'SignUp'}"
                )
                b-icon.pl-1(icon="cloud-download")
                span Download the list
              a.button.is-primary(
                v-else
                href="/static/downloads/Frequency-List-bonus.zip"
                target="_blank"
                )
                b-icon.pl-1(icon="cloud-download")
                span Download the list

            b-dropdown
              a.navbar-item.has-size-42px(
              slot="trigger"
              v-if="user.id"
              )
                user-picture(:user="user")
              b-dropdown-item.is-flex.has-flex-center-items(
              @click="logout"
              )
                b-icon(icon="exit-to-app")
                span Sign out

            a.navbar-item(
              v-if="!user.id"
              @click="openSignInModal"
              )
              | Log in
            <!--router-link.navbar-item.is-active(:to="{name: 'ListPage'}") List-->
</template>

<script>
  import userPicture from '@/components/UserPictureUI';
  // import signUp from '@/components/SignUp';
  import signIn from '@/components/SignIn';
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: 'FrontMenu',
    data () {
      return {
        showNavBar: false
      }
    },
    components: {
      userPicture
    },
    computed: {
      ...mapGetters(["user", 'videoSeen']),
    },
    mounted () {
    },
    methods: {
      ...mapActions(['toggleVideoSeen']),
      openSignInModal() {
        this.$modal.open({
          parent: this,
          component: signIn,
          hasModalCard: false
        })
      },
      // openSignUpModal() {
      //   this.$modal.open({
      //     parent: this,
      //     component: signUp,
      //     hasModalCard: false
      //   })
      // },
      logout() {
        this.$store.dispatch("setUser", {});
        this.$auth.logout({
          redirect: {name: 'ListPage'}
        });
      }
    }
  }
</script>

<style>
  .brand{
    display:-ms-flexbox;
    display:flex;
    -ms-flex-align:center;
    align-items:center;
    line-height:1
  }
  .brand .brand-icon{
    width:56px;
    height:56px;
    margin-right:1rem;
    transition-duration:172ms;
    will-change:width, height, margin-right
  }
  .brand .brand-icon img {
    display:block;
    max-width:100%;
    max-height:100%;
    border-radius: 9px;
    padding: 0.7rem;
  }
  .brand .brand-title {
    text-align: left;
    font-family: 'Montserrat';
    font-weight: 700;
    font-size:1.25rem;
    color:#463853;
    transition-duration:172ms;
    will-change:transform
  }
  .brand .brand-subtitle {
    margin-top:0.25rem;
    font-size:1.125rem;
    font-weight: 300;
    color:#998DA0;
    opacity:1;
    transition-duration:172ms;
    will-change:opacity, transform
  }
</style>



// WEBPACK FOOTER //
// src/components/FrontMenu.vue